import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import { useEffect, useState } from 'react';
import CustomAlert from './components/Alert/CustomAlert';

function App() {
    const [alertMsg, setAlertMsg] = useState("");
    useEffect(() => {
    const handlePopState = (e) => {
      window.history.go(1);
      setAlertMsg("ブラウザの戻るボタンは無効となっています、画面内の戻るもしくはページリンクを使用してください。")
    };

    // Add event listener on mount
    window.addEventListener('popstate', handlePopState);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  const handleCloseAlert = () => setAlertMsg("");
  return (
    <AppProvider>
      <CustomAlert message={alertMsg} onClose={handleCloseAlert} />
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
